import {RouteState} from '@stores/route.store';
import {ConnectionState} from '@common/ble/dist/index.js';
import * as FTC from '@common/utils/dist/feature-toggles/core.js';
import * as PL2 from '@common/utils/dist/models/models-pl2.js';
import {TypeUtilsPL2 as TU} from '@common/utils/dist/utils/type-utils.js';
import {StoreEventsPipes as SEP} from '@utils/store-events-pipes';

export interface VideoTutorialTrigger {
  route?: Partial<SEP.StoreEvent<RouteState, SEP.RouteStoreEvents>>;
  user?: Partial<SEP.StoreEvent<PL2.User, SEP.UserStoreEvents>>;
  device?: TU.DeepPartial<
    SEP.StoreEvent<ConnectionState, SEP.ConnectionStoreEvents>
  >;
}

export interface VideoTutorialCondition {
  route?: Partial<RouteState>;
  user?: Partial<PL2.User>;
  device?: TU.DeepPartial<ConnectionState>;
  feature?: Partial<FTC.FeatureDecisions>;
}

export interface TriggersAndConditions {
  triggers: Array<VideoTutorialTrigger>;
  conditions: Array<VideoTutorialCondition>;
}

export interface VideoTutorial {
  id: string;
  videoUrl: string;
  title: string;
  activation: TriggersAndConditions;
  deactivation?: TriggersAndConditions;
  learnMoreUrl?: string;
  openInSameTab?: boolean;
}

export const videoTutorialConfig: VideoTutorial[] = [
  {
    id: 'explore-tutorial',
    videoUrl: 'https://www.loom.com/share/54be2263f8104166bcbda8502097dd2a',
    title: 'Take a Quick Tour of Your Workspace',
    learnMoreUrl:
      'https://app.thepocketlab.com/lab-report/3ZsE6Df70008UzW701oswo/print',
    activation: {
      triggers: [
        {
          route: {
            event: SEP.RouteStoreEvents.RouteChanged,
            state: {pageName: 'explore'},
          },
        },
      ],
      conditions: [
        {
          user: {role: PL2.Role.Pro},
          route: {pageName: 'explore'},
        },
        {
          user: {role: PL2.Role.Lite},
          route: {pageName: 'explore'},
        },
      ],
    },
  },
  {
    id: 'assignment-tutorial',
    videoUrl:
      'https://www.loom.com/share/92873d3a911c4befa328d8fb2bfe277b?sid=f8223883-6223-4015-be7f-53c1f81951f7',
    title: 'How to Use the Assignment Dashboard',
    activation: {
      triggers: [
        {
          route: {
            event: SEP.RouteStoreEvents.RouteChanged,
            state: {pageName: 'assignment'},
          },
        },
      ],
      conditions: [
        {
          user: {role: PL2.Role.Pro},
          route: {pageName: 'assignment'},
        },
        {
          user: {role: PL2.Role.Lite},
          route: {pageName: 'assignment'},
        },
      ],
    },
    deactivation: {
      triggers: [
        {route: {event: SEP.RouteStoreEvents.RouteChanged, state: {}}},
      ],
      conditions: [],
    },
    learnMoreUrl: 'https://support.thepocketlab.com/knowledge/auto-scoring',
  },
  {
    id: 'odyssey-tutorial',
    videoUrl:
      'https://www.loom.com/share/f553cc3d66f94a37b622df0639205162?sid=d3a67681-2aef-400b-a54a-891eb8b0e748',
    title: 'Getting Started with Odyssey',
    activation: {
      triggers: [
        {
          device: {
            event: SEP.ConnectionStoreEvents.DeviceConnected,
            state: {deviceConfig: {id: 'odyssey'}},
          },
        },
      ],
      conditions: [
        {
          user: {role: PL2.Role.Pro},
          device: {deviceConfig: {id: 'odyssey'}},
        },
        {
          user: {role: PL2.Role.Lite},
          device: {deviceConfig: {id: 'odyssey'}},
        },
      ],
    },
    deactivation: {
      triggers: [
        {route: {event: SEP.RouteStoreEvents.RouteChanged, state: {}}},
        {
          device: {
            event: SEP.ConnectionStoreEvents.DeviceDisconnected,
            state: null,
          },
        },
      ],
      conditions: [],
    },
    learnMoreUrl:
      'https://support.thepocketlab.com/knowledge/getting-started-with-pocketlab-odyssey',
  },
  {
    id: 'kesler-tutorial',
    videoUrl:
      'https://www.loom.com/share/63001d271e10452f9f4a8598c3c715c1?sid=aedfdd8d-5f6c-458a-af3c-61cab920e0a5',
    title: 'Welcome to Kesler Science',
    learnMoreUrl:
      'https://app.thepocketlab.com/lab-report/RP-R6wEl0008-BcR01zmM1?ref=%2Fcurriculum%2FRP-R6wEl0008-BcR',
    openInSameTab: true,
    activation: {
      triggers: [
        {
          route: {
            event: SEP.RouteStoreEvents.RouteChanged,
            state: {pageName: 'curriculum', containerId: 'RP-R6wEl0008-BcR'},
          },
        },
      ],
      conditions: [
        {
          user: {role: PL2.Role.Pro},
          route: {pageName: 'curriculum', containerId: 'RP-R6wEl0008-BcR'},
        },
        {
          user: {role: PL2.Role.Lite},
          route: {pageName: 'curriculum', containerId: 'RP-R6wEl0008-BcR'},
        },
      ],
    },
    deactivation: {
      triggers: [
        {route: {event: SEP.RouteStoreEvents.RouteChanged, state: {}}},
      ],
      conditions: [],
    },
  },
];
